import { type ReactNode, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useApp from '@/pages/App.context';
import useReview from '@/pages/ReviewLayout.context';
import Reviewer from './Reviewer';
import styles from './Welcome.module.scss';

const Welcome = () => {
  const { t } = useTranslation(['review']);
  const { setAppTitle } = useApp();
  const { overallLoading, review, visitor } = useReview();

  useEffect(() => {
    setAppTitle(t('review:welcome.title'));
  }, [setAppTitle, t]);

  let content: ReactNode;

  if (overallLoading) {
    content = (
      <div className={styles.loading}>{t('review:welcome.loadingData')}</div>
    );
  } else if (!review) {
    content = (
      <div className={styles.error}>
        {t('review:welcome.errorLoadingReview')}
      </div>
    );
  } else if (!visitor) {
    content = (
      <div className={styles.error}>{t('review:welcome.errorLoadingUser')}</div>
    );
  } else {
    content = <Reviewer />;
  }

  return (
    <div className={styles.pane}>
      <h1 className={styles.h1}>{t('review:welcome.headline')}</h1>
      {content}
      <div className={styles.footer}>{t('review:welcome.footer')}</div>
    </div>
  );
};

export default Welcome;
